import React, { Component } from "react";
import { Tooltip, Button, InputGroup, ButtonGroup, Center } from "@chakra-ui/react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faUserEdit, faUmbrellaBeach, faUserClock, faSlash, faRecycle, faMailBulk } from "@fortawesome/free-solid-svg-icons";



export default class SubscriberMgmtButtonPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {

    return (
      <Center margin='10px'>
        <ButtonGroup isAttached>
          <Tooltip label="Add New Subscriber">
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faPlusCircle} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onNewSubscriberRequest}>
              New
            </Button>
          </Tooltip>
          <Tooltip label="Edit Selected Subscriber">
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faUserEdit} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onEditSubscriberRequest}>
              Edit
            </Button>
          </Tooltip>
          <Tooltip label={(this.props.isStatusActive) ? "Retire Subscriber" : "Activate Subscriber"}>
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={(this.props.isStatusActive) ? faUmbrellaBeach : faUserClock} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onBtnToggleRetireSelectedSubscriber}>
              {(this.props.isStatusActive) ? "Retire" : "Activate"}
            </Button>
          </Tooltip> 

          <Tooltip label="Delete Subscriber Permanently">
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faSlash} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onDeleteSubscriberRequest}>
              Delete
            </Button>
          </Tooltip>


          <Tooltip label="Send Test Message">
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faMailBulk} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={(e) => this.props.onSendTestMessageRequest()}>
              Send Test Message
            </Button>
          </Tooltip>

          <Tooltip label="Refresh List">
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faRecycle} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.refreshData}>
              Refresh
            </Button>
          </Tooltip>
        </ButtonGroup>

      </Center>
    );
  }
}
